import * as React from 'react';
import PropTypes from 'prop-types';
import { PrivacyStrategyStates } from '../typing';
import { getPrivacyStrategy } from '../action/login';

require('./component.scss');

/**
 * 用户协议展示
 * 
 * @author Jiawei Chen
 * @since 18/5/2022
 */
class PrivacyStrategy extends React.PureComponent<any, PrivacyStrategyStates> {
  constructor(props) {
    super(props);

    this.state = {
      privacyStrategy: '',
    };
  }

  componentDidMount(): void {
    getPrivacyStrategy().then(d => this.setState({
      privacyStrategy: d,
    }));
  }

  render() {
    const { privacyStrategy } = this.state;
    return (
      <div dangerouslySetInnerHTML={{ __html: privacyStrategy }}></div>
    );
  }
}

(PrivacyStrategy as React.ComponentType).defaultProps = {
  loading: true,
  location: { pathname: '' },
};

(PrivacyStrategy as React.ComponentType<any>).contextTypes = {
  numeric: PropTypes.object,
  intl: PropTypes.object,
};

export default PrivacyStrategy;
